import React from "react"
import { ErrorBoundary } from "../ErrorBoundary"
import { ConnectionSettings } from "../shopify/ConnectionSettings"
import { BigqueryConnectionSettings } from "../bigquery/BigqueryConnectionSettings"
import { SlackConnectionSettings } from "../slack/SlackConnectionSettings"

// Settings → Integrations page. Standalone mount; nests under Settings. Holds
// the connection panels (Shopify + Google Analytics / BigQuery + Slack).
export default function SettingsIntegrationsApp({
  connectionPath,
  bigqueryConnectionPath,
  slackConnectionPath,
  partnerId,
  copy,
}) {
  return (
    <ErrorBoundary>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">{copy.title}</h1>
          <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">{copy.subtitle}</p>
        </div>
        <div className="space-y-6">
          <ConnectionSettings
            connectionPath={connectionPath}
            partnerId={partnerId}
            copy={copy.connection}
          />
          <BigqueryConnectionSettings
            connectionPath={bigqueryConnectionPath}
            copy={copy.bigquery}
          />
          <SlackConnectionSettings
            connectionPath={slackConnectionPath}
            copy={copy.slack}
          />
        </div>
      </div>
    </ErrorBoundary>
  )
}
